import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
// import TextField from "@material-ui/core/TextField";
// import Sendmessage from "../button/globleButtons"
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles(theme => ({
  
  root: {
    background: 'linear-gradient(45deg, #EF8354 30%, #EF8354 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 38,
    width: 174,
  
  },
  label: {
    textTransform: 'capitalize',
  },
  paper: {
    background: 'transparent' ,
    boxShadow: "none",
    backgroundColor:"#4F5D75"
  },
  TextField:{
    backgroundColor:"white",
    borderColor:"white",
    marginTop:"5%",
    float:"left",
    width:"99%"
  },
  textarea:{
    marginTop:"5%",
    width:"99%",
   height:"90%",
  },
  style:{
    marginTop:"6%",
    justifyContent:'center' ,
    float:"right",
    marginBottom:"5%"
  },
  contact:{
    textAlign:"center",
    paddingTop:"3%",
    marginTop:"5%",
    color:"#F7F7F7"
  },
  footerText:{
    marginBottom:"3%",
    textAlign:"center",
    marginTop:"4%"
  },
  paper1: {
    background: 'transparent',
    boxShadow: "none",
    backgroundColor:"#2D3142",
    color:"#F7F7F7",
    borderRadius:"0%"
  },
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <div>
      {/* <Paper className={classes.paper}>

      <Typography  variant=" h1" component="h1" className={classes.contact}>
             CONTACT US
      </Typography>
          <Grid container  style={{paddingLeft:"8%",paddingRight:"8%"}}>
            <Grid item xs={12} sm={6}>
            <TextField 
                    className={classes.TextField}
                    label="*Your Name"
                    variant="filled"
                 />   

                <TextField 
                    className={classes.TextField} 
                    id="filled-basic"
                    label="*Your email"
                    variant="filled"
                 />

                 <TextField 
                      className={classes.TextField}
                      id="filled-basic"
                      label="*Phone no"
                      variant="filled"
                 />
            </Grid>

            <Grid item xs={12} sm={6}>
                    <textarea
                      className={classes.textarea}
                      placeholder="*Your message"
                      label=" Your Message"
                      
                    >
                    </textarea>
            </Grid>
              <div style={{marginTop:"2%",marginBottom:"4%"}}>
                <Sendmessage buttonname="Send Message"/>
                </div>
            </Grid>
      </Paper> */}
      {/* <Paper style={{height:"400px"}}></Paper> */}
      <Paper className={classes.paper1}>
                <Grid container style={{paddingLeft:"8%",paddingRight:"8%"}}>
                        <Grid item xs={12}>
                            <Typography  className={classes.footerText}>
                                Copyright 123Mentor.com
                            </Typography>
            
                        </Grid>
                </Grid>
        </Paper>

    </div>
  );
}